import { useSelector, useDispatch } from 'react-redux'
import { itemsFetchData } from '../../redux/items'
import { parseSubjectsFromUrl } from '../../SearchUtils'
import { detectBrowserCoordinates } from '../../../lib/detectBrowserCoordinates'

function OrderBy() {
  const currentFilters = useSelector(
    (state) => state.items.currentFilters || {}
  )
  const dispatch = useDispatch()
  const fetchData = (filters) => dispatch(itemsFetchData({ filters }))

  const options = {
    shuffle: { label: I18n.t('search.sort_types.shuffle'), icon: 'random' },
    distance: { label: I18n.t('search.sort_types.nearest'), icon: 'location' },
    newest: { label: I18n.t('search.sort_types.newest'), icon: 'clock' },
    price_asc: {
      label: I18n.t('search.sort_types.price_asc'),
      icon: 'sort-numeric-up',
    },
    price_desc: {
      label: I18n.t('search.sort_types.price_desc'),
      icon: 'sort-numeric-down',
    },
  }

  const submitSort = (sortValue) => {
    const newFilters = { ...currentFilters }

    newFilters.sort = sortValue
    newFilters.subjects = parseSubjectsFromUrl()

    fetchData(newFilters)
  }

  const handleChangeSort = (sortValue) => {
    if (sortValue === 'distance') {
      detectBrowserCoordinates(
        () => submitSort(sortValue),
        () => submitSort(sortValue)
      )
    } else {
      submitSort(sortValue)
    }
  }

  return (
    <div
      className="dropdown sort-by d-inline ms-auto"
      style={{ height: '45px' }}
    >
      <button
        type="button"
        className="btn btn-sm text-primary dropdown-toggle"
        id="dropdown-filter-sort-by"
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <i
          className={`far fa-${
            (
              options[currentFilters.sort] ||
              options[App.State.defaultSortValue]
            ).icon
          } fa-fw`}
        />{' '}
        {
          (options[currentFilters.sort] || options[App.State.defaultSortValue])
            .label
        }
      </button>
      <div
        className="dropdown-menu dropdown-menu-end w-100"
        aria-labelledby="dropdown-filter-sort-by"
      >
        <button
          type="button"
          className="dropdown-item"
          onClick={() => handleChangeSort('shuffle')}
        >
          <i className={`far fa-${options.shuffle.icon} fa-fw`} />{' '}
          {I18n.t('search.sort_types.shuffle')}
        </button>

        <div className="dropdown-divider" />

        <button
          type="button"
          className="dropdown-item"
          onClick={() => handleChangeSort('distance')}
        >
          <i className={`far fa-${options.distance.icon} fa-fw`} />{' '}
          {I18n.t('search.sort_types.nearest')}
        </button>

        <div className="dropdown-divider" />

        <button
          type="button"
          className="dropdown-item"
          onClick={() => handleChangeSort('newest')}
        >
          <i className={`far fa-${options.newest.icon} fa-fw`} />{' '}
          {I18n.t('search.sort_types.newest')}
        </button>

        <div className="dropdown-divider" />

        <button
          type="button"
          className="dropdown-item"
          onClick={() => handleChangeSort('price_desc')}
        >
          <i className={`far fa-${options.price_desc.icon} fa-fw`} />{' '}
          {I18n.t('search.sort_types.price_desc')}
        </button>

        <div className="dropdown-divider" />

        <button
          type="button"
          className="dropdown-item"
          onClick={() => handleChangeSort('price_asc')}
        >
          <i className={`far fa-${options.price_asc.icon} fa-fw`} />{' '}
          {I18n.t('search.sort_types.price_asc')}
        </button>
      </div>
    </div>
  )
}

export default OrderBy
